import { render, staticRenderFns } from "./CheckItemDefectRemark.vue?vue&type=template&id=2b0866e6&scoped=true&"
import script from "./CheckItemDefectRemark.vue?vue&type=script&lang=js&"
export * from "./CheckItemDefectRemark.vue?vue&type=script&lang=js&"
import style0 from "./CheckItemDefectRemark.vue?vue&type=style&index=0&id=2b0866e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0866e6",
  null
  
)

export default component.exports